import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { enrichedContextApiToEnrichedContextEntity, enrichedContextToEnrichedContextApi } from '../../entities/EnrichedContext';
import { pagingMetadataToCursorResponse } from '../../utils/PagingUtils';
import { BaseClient } from '../BaseClient';
export class EnrichedContextClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createEnrichedContextImpl", void 0);
    _defineProperty(this, "getEnrichedContextImpl", void 0);
    _defineProperty(this, "updateEnrichedContextImpl", void 0);
    _defineProperty(this, "deleteEnrichedContextImpl", void 0);
    _defineProperty(this, "queryEnrichedContextsImpl", void 0);
    _defineProperty(this, "createClientEnrichedContextImpl", void 0);
  }
  async createEnrichedContext(data) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        enrichedContext
      } = await this.request(this.createEnrichedContextImpl({
        enrichedContext: {
          entityId: data.entityId,
          context: data.context
        }
      }), ...args);
      return this.convertToEntity(enrichedContext);
    } catch (error) {
      this.logError('createEnrichedContext', 'Failed to create enriched context', {
        data
      }, error);
      throw error;
    }
  }
  async createClientEnrichedContext(_ref) {
    let {
      entityId,
      contacts,
      userMessage,
      userIntent,
      keywords
    } = _ref;
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      await this.request(this.createClientEnrichedContextImpl({
        entityId,
        contacts,
        userMessage,
        userIntent,
        keywords
      }), ...args);
      return;
    } catch (error) {
      this.logError('createEnrichedContext', 'Failed to create enriched context', {}, error);
      throw error;
    }
  }
  async getEnrichedContext(enrichedContextId) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      const {
        enrichedContext
      } = await this.request(this.getEnrichedContextImpl({
        enrichedContextId
      }), ...args);
      return this.convertToEntity(enrichedContext);
    } catch (error) {
      this.logError('getEnrichedContext', 'Failed to get enriched context', {
        enrichedContextId
      }, error);
      throw error;
    }
  }
  async getEnrichedContextByEntityId(entityId) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      const {
        enrichedContexts
      } = await this.request(this.queryEnrichedContextsImpl({
        query: {
          filter: {
            entityId
          }
        }
      }), ...args);
      if (!(enrichedContexts != null && enrichedContexts.length) || enrichedContexts.length > 1) {
        this.logWarn('getEnrichedContextByEntityId', 'Multiple or none enriched contexts found for entity id', {
          entityId,
          enrichedContexts
        });
        return null;
      } else {
        return this.convertToEntity(enrichedContexts[0]);
      }
    } catch (error) {
      this.logError('getEnrichedContextByEntityId', 'Failed to get enriched context by entity id', {
        entityId
      }, error);
      throw error;
    }
  }
  async updateEnrichedContext(data) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      const {
        enrichedContext
      } = await this.request(this.updateEnrichedContextImpl({
        enrichedContext: enrichedContextToEnrichedContextApi(data)
      }), ...args);
      return this.convertToEntity(enrichedContext);
    } catch (error) {
      this.logError('updateEnrichedContext', 'Failed to update enriched context', {
        data
      }, error);
      throw error;
    }
  }
  async deleteEnrichedContext(enrichedContextId) {
    try {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      await this.request(this.deleteEnrichedContextImpl({
        enrichedContextId
      }), ...args);
    } catch (error) {
      this.logError('deleteEnrichedContext', 'Failed to delete enriched context', {
        enrichedContextId
      }, error);
      throw error;
    }
  }
  async queryEnrichedContexts(query) {
    try {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }
      const {
        enrichedContexts,
        pagingMetadata
      } = await this.request(this.queryEnrichedContextsImpl({
        query
      }), ...args);
      return {
        items: (enrichedContexts ?? []).map(item => this.convertToEntity(item)),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryEnrichedContexts', 'Failed to query enriched contexts', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(enrichedContext) {
    try {
      return enrichedContextApiToEnrichedContextEntity(enrichedContext);
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert enriched context', {
        enrichedContext
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'EnrichedContextClient';
  }
}
//# sourceMappingURL=EnrichedContextClientBase.js.map